import React from 'react';

const Notification = () => <div>Notification</div>;

export default Notification;
